import React from 'react';
import { Link } from 'react-router-dom';
import SITE_CONFIG from '../../config/site.config';

const Footer = ({ isAdmin = false }) => {
  if (isAdmin) {
    // Simple admin footer
    return (
      <div className="footer">
        <div className="container-fluid copyright">
          <div className="row">
            <div className="col-md-12 text-center">
              <p>&copy; {SITE_CONFIG.name}, All Right Reserved. | Managed By Team SSVASS</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Footer Start */}
      <div className="footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-3 col-md-6 text-center">
              <img src="/img/mdss_logo.png" style={{ height: '135px' }} alt="SSVASS Logo" />
              <div className="footer-social">
                <a className="btn btn-custom" href={SITE_CONFIG.twitter} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a className="btn btn-custom" href={SITE_CONFIG.facebook} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a className="btn btn-custom" href={SITE_CONFIG.youtube} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
                <a className="btn btn-custom" href={SITE_CONFIG.instagram} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a className="btn btn-custom" href={SITE_CONFIG.linkedin} target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer-contact">
                <p>
                  SSVASS Enterprises is back with its {SITE_CONFIG.edition} edition of SSVASS Gems & Jewellery
                  Exhibition, (AN iso 9001:2015 certified exhibition) scheduled to be held from {SITE_CONFIG.eventDate} at {SITE_CONFIG.eventVenue}. SSVASS-ज्वैलरी महोत्सव-2026, {SITE_CONFIG.edition} edition will open up unlimited opportunities for
                  the jewelry industry of India.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="footer-contact">
                <h2>Contact Us</h2>
                <p>
                  <strong>{SITE_CONFIG.name}</strong>
                </p>
                <p>
                  <i className="fa fa-map-marker-alt"></i>
                  <span>
                    <strong>Head Office:</strong><br />
                    {SITE_CONFIG.addressLines.map((line) => (
                      <React.Fragment key={line}>
                        {line}<br />
                      </React.Fragment>
                    ))}
                  </span>
                </p>
                <p>
                  <i className="fa fa-phone-alt"></i>
                  Phone: <a href={`tel:${SITE_CONFIG.phoneDisplay.replace(/\s/g, '')}`}>{SITE_CONFIG.phoneDisplay}</a>
                </p>
                <p>
                  <i className="fa fa-building"></i>
                  Office: <a href={`tel:${SITE_CONFIG.officePhone}`}>{SITE_CONFIG.officePhone}</a>
                </p>
                <p>
                  <i className="fa fa-envelope"></i>
                  Email: <a href={`mailto:${SITE_CONFIG.email}`}>{SITE_CONFIG.email}</a>
                </p>
                <p>
                  <i className="fa fa-globe"></i>
                  Website: <a href={SITE_CONFIG.websiteUrl} target="_blank" rel="noopener noreferrer">{SITE_CONFIG.websiteDisplay}</a>
                </p>
                <p>
                  <i className="fa fa-clock"></i>
                  Working Hours: {SITE_CONFIG.workingDays}, {SITE_CONFIG.workingHours}
                </p>
              </div>
            </div>
            <div className="col-lg-2 col-md-6">
              <div className="footer-link">
                <h2>Useful Links</h2>
                <Link to="/">Home</Link>
                <Link to="/about">About us</Link>
                <Link to="/gallery">Gallery</Link>
                <Link to="/contact">Contact</Link>
                <Link to="/visitor">Visitor</Link>
                <Link to="/terms">Terms &amp; Conditions</Link>
                <Link to="/privacy">Privacy Policy</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid copyright">
          <div className="row">
            <div className="col-md-6">
              <p>
                &copy; <a href="https://mdss.in">{SITE_CONFIG.name}</a>, All Right Reserved.
              </p>
            </div>
            <div className="col-md-6">
              <p>Managed By Team SSVASS</p>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}

      {/* Back to top button */}
      <a href="#" className="back-to-top">
        <i className="fa fa-chevron-up"></i>
      </a>
    </>
  );
};

export default Footer;
